export default __webpack_public_path__ + "static/media/sg553.36673ff9.svg";